
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 32 29\" id=\"icon-star\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g id=\"icon-star_Shape_1_copy_4\"> <g> <polygon points=\"31.399,10.791 20.396,9.817 16.038,-0.003 11.68,9.817 0.677,10.791 8.987,17.832 6.544,28.254 \r\n\t\t\t16.038,22.786 25.532,28.254 23.089,17.832 \t\t\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "icon-star");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/star.svg
 ** module id = 229
 ** module chunks = 24
 **/